var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassEyeHid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.927 9.144c.545 0 1.067-.214 1.453-.596a2.024 2.024 0 00.594-1.615L7.748 9.137c.059.005.118.007.179.007zM14.729.818l-.784-.775a.147.147 0 00-.207 0l-2.006 1.986c-1.107-.56-2.35-.84-3.732-.84-3.527 0-6.158 1.818-7.894 5.454a1.086 1.086 0 000 .936c.694 1.446 1.529 2.605 2.506 3.477L.67 12.976a.144.144 0 000 .206l.784.775a.148.148 0 00.207 0L14.73 1.024a.145.145 0 000-.205zM4.697 7.11c0-.552.144-1.095.42-1.575.274-.48.67-.883 1.148-1.167a3.254 3.254 0 013.183-.078l-.893.883a2.077 2.077 0 00-2.081.5 2.016 2.016 0 00-.504 2.06l-.893.882a3.154 3.154 0 01-.38-1.505z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.894 6.641c-.646-1.346-1.415-2.444-2.306-3.293l-2.645 2.618a3.167 3.167 0 01-.734 3.404c-.44.437-1 .738-1.61.866-.611.13-1.246.08-1.829-.14l-2.243 2.22c1.04.477 2.198.715 3.473.715 3.527 0 6.158-1.818 7.894-5.454a1.085 1.085 0 000-.936z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEyeHid);
export default __webpack_public_path__ + "static/media/pass-eye-hid.e59a074ce66147a7eb4b1716b48c3d04.svg";
export { ForwardRef as ReactComponent };